




























































































































import {
  computed,
  defineComponent,
  PropType,
  toRefs,
  ref,
  watch
} from '~/utils/nuxt3-migration'
import {
  AuditActingUser,
  AuditRequest,
  AuditRequestStatusStatus
} from '~/models/audit/request'
import { format } from '~/utils/date'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import AuditRequestStatusBadge from '~/components/car/account/audits/requests/AuditRequestStatusBadge.vue'
import CPing from '~/components/shared/configurable/timeline/CPing.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { useDep } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { handleError } from '~/utils/http'
import { useSnackbar } from '~/compositions/snackbar'
import { useLogger } from '~/compositions/logger'
import { AxiosError } from 'axios'
import { useI18n } from '~/compositions/i18n'
import { deepJsonCopy } from '~/utils/object'

export default defineComponent({
  components: {
    CBadge,
    CPing,
    AuditRequestStatusBadge,
    CAvatar,
    CConfirmationModal
  },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest | null>,
      required: true
    },
    to: { type: [Object, String], default: null, required: false }
  },
  setup(props) {
    const { auditRequest } = toRefs(props)
    const snackbar = useSnackbar()
    const logger = useLogger()
    const { t } = useI18n()
    const auditRequestService = useDep(AuditRequestService)

    const auditRequestInternal = ref(deepJsonCopy(auditRequest.value))
    const isAcceptConfirmationVisible = ref(false)
    const isLoading = ref(false)

    const formatDate = (dateStr: string) => {
      return format(dateStr)
    }

    watch(auditRequest, newVal => {
      auditRequestInternal.value = newVal
    })

    const { getters } = useNamespacedStore(CLASSIFIED_VIEW_NS)

    const userStore = useNamespacedStore<UserState>(USER_NS)
    const { getters: userGetters } = userStore

    const hasAuditRequiresAcceptance = computed(
      () => auditRequestInternal.value?.requiresAcceptance
    )

    const userIsPayer = computed<boolean>(() => {
      return (
        auditRequestInternal.value?.currentUserRole === AuditActingUser.PAYER
      )
    })

    const isStatusPendingAcceptance = computed(
      () =>
        auditRequestInternal.value.currentStatus.status ===
        AuditRequestStatusStatus.PENDING_ACCEPTANCE
    )

    const title = computed<string>(() => {
      if (userIsPayer.value) {
        return auditRequestInternal.value.requestedForClassified.title
      }
      return auditRequestInternal.value.requestedByUser.displayName
    })

    const mainThumb = computed<string>(() => {
      if (userIsPayer.value) {
        return auditRequestInternal.value.requestedForClassified.thumb
      }
      return auditRequestInternal.value.requestedByUser.displayPhoto
    })

    const isSelfAudit = computed(() => {
      return (
        userGetters('userIds').includes(
          auditRequestInternal.value.requestedByUser.id
        ) && getters('userIsAdminOrOwner')
      )
    })

    async function acceptAuditRequest() {
      try {
        isLoading.value = true
        const {
          auditRequest: auditRequestRes
        } = await auditRequestService.acceptAuditRequest(
          auditRequestInternal.value.id
        )
        auditRequestInternal.value = auditRequestRes
        snackbar.success(t('acceptance_audit_successful'))
      } catch (e) {
        handleError(e as AxiosError, snackbar, logger, t)
      } finally {
        isLoading.value = false
      }
    }

    return {
      formatDate,
      userIsPayer,
      title,
      mainThumb,
      isSelfAudit,
      acceptAuditRequest,
      hasAuditRequiresAcceptance,
      isLoading,
      isAcceptConfirmationVisible,
      auditRequestInternal,
      isStatusPendingAcceptance
    }
  }
})
